/**
 * Field type catalog: types available in the form builder.
 * Each entry tells the editor which sub-properties the field exposes.
 */
export const FIELD_TYPES = [
  { value: 'text',     label: 'Tek satır metin',  hasOptions: false, hasMaxLength: true,  hasPlaceholder: true },
  { value: 'textarea', label: 'Çok satır metin',  hasOptions: false, hasMaxLength: true,  hasPlaceholder: true },
  { value: 'number',   label: 'Numara / telefon', hasOptions: false, hasMaxLength: true,  hasPlaceholder: true },
  { value: 'select',   label: 'Dropdown',         hasOptions: true,  hasMaxLength: false, hasPlaceholder: false },
  { value: 'radio',    label: 'Tek seçim (radio)',hasOptions: true,  hasMaxLength: false, hasPlaceholder: false },
  { value: 'chips',    label: 'Görselli chip',    hasOptions: true,  hasMaxLength: false, hasPlaceholder: false },
  { value: 'checkbox', label: 'Çoklu seçim',      hasOptions: true,  hasMaxLength: false, hasPlaceholder: false },
  { value: 'file',     label: 'Dosya yükleme',    hasOptions: false, hasMaxLength: false, hasPlaceholder: false, hasAccept: true },
  { value: 'dialog',   label: 'Sözleşme / popup', hasOptions: false, hasMaxLength: false, hasPlaceholder: false, hasContent: true },
];

export function newField(type = 'text') {
  return {
    handle: `field_${Math.random().toString(36).slice(2, 8)}`,
    type,
    label: '',
    required: false,
    placeholder: '',
    helpText: '',
    maxLength: null,
    accept: '',
    content: '',
    confirmLabel: '',
    rules: '',
    options: [],
  };
}

export function newOption() {
  return { label: '', value: '', price: 0, helpText: '' };
}
